import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Auth0Config } from 'config'
import { attachUsageIdentity } from 'utils/usage-identity'

export function useUsageIdentity() {
	const { isAuthenticated, isLoading, getAccessTokenSilently, user } =
		useAuth0()
	useEffect(() => {
		if (isLoading) return
		return attachUsageIdentity(
			window,
			isAuthenticated,
			() =>
				getAccessTokenSilently({
					audience: Auth0Config.audience,
					scope: Auth0Config.scope
				}),
			user?.sub
		)
	}, [isAuthenticated, isLoading, getAccessTokenSilently, user?.sub])
}
